// import ImgTag from "@/components/Helpers/ImgTag";
// import { useState } from "react";
// import MadfuModal from "./MadfuModal";

// const Madfu = ({ locale, amount }) => {
//   const [show, setShow] = useState(false);
//   return (
//     amount >= process.env.NEXT_PUBLIC_MADFU_LIMIT_FROM &&
//     amount <= process.env.NEXT_PUBLIC_MADFU_LIMIT_TO && (
//       <>
//         <div
//           onClick={() => setShow(true)}
//           className="flex items-center gap-3 p-3 mt-2 border rounded-md"
//         >
//           <ImgTag
//             width={85}
//             height={28}
//             className="w-16 max-[991px]:w-[85px] h-auto object-contain"
//             src="/imgs/madfu/new-logo.png"
//             alt="Madfu"
//           />
//           <span>
//             {locale === "ar" ? (
//               <>
//                 4 دفعات بقيمة{" "}
//                 <span className="font-bold">
//                   {(amount / 4)?.toFixed(2)} ر.س .
//                 </span>
//                 شهرياً، بدون رسوم تأخير، متوافق مع أحكام الشريعة الإسلامية.
//               </>
//             ) : (
//               <>
//                 3 payments of
//                 <span className="font-bold">
//                   {" "}
//                   SAR {(amount / 3)?.toFixed(2)}
//                 </span>
//                 /mo, No late fees, Sharia compliant.
//               </>
//             )}
//             <span className="text-sm font-bold underline cursor-pointer max-[991px]:text-base">
//               {locale === "ar" ? " اعرف أكثر" : " Learn more"}
//             </span>
//           </span>
//         </div>
//         <MadfuModal {...{ amount, locale, show, setShow }} />
//       </>
//     )
//   );
// };

// export default Madfu;

// import MadfuWidgetAr from "@/components/icons/MAdfuWidgetAr";
// import MadfuWidgetCheckedAr from "@/components/icons/MAdfuWidgetCheckedAr";
// import MadfuWidgetCheckedEn from "@/components/icons/MadfuWidgetCheckedEn";
// import MadfuWidgetEn from "@/components/icons/MadfuWidgetEn";
import { useRouter } from "next/router";
import { useRef, useState } from "react";
import MadfuWidgetModal from "./MadfuWidgetModal";
import useOnClickOutside from "@/hooks/useOnClickOutside";
import { useTranslation } from "react-i18next";
import ImgTag from "@/components/Helpers/ImgTag";
import CurrencyIcon from "@/components/icons/CurrencyIcon";

const Madfu = ({amount}) => {
  const { locale } = useRouter();
  const [show, setShow] = useState(false);
  const refModel = useRef();
  const refBtn = useRef();
  useOnClickOutside([refModel, refBtn], () => setShow(false));
  const { t } = useTranslation("common");
  return (
    <div className="flex items-center justify-center mt-2 rounded-md max-[470px]:items-start max-[470px]:justify-start">
      {/* {locale === "en" ? (
        show === true ? (
          <MadfuWidgetCheckedEn setShow={setShow} />
        ) : (
          <MadfuWidgetEn {...{ setShow, show }} />
        )
      ) : show === true ? (
        <MadfuWidgetCheckedAr setShow={setShow} />
      ) : (
        <MadfuWidgetAr {...{ setShow, show }} />
      )} */}

      {/* {locale === "en" ? (
        <p className="w-full text-lg bg-gray-500">
          
          <ImgTag
                    src={`/imgs/madfu/new/{madfu-logo-${locale}}.png`}
                    alt="madfu logo"
                    className="object-contain h-20"
                  />
          <span>{t("Split up to 6 Payments")}</span>
        </p>
      ) : (
        <p className="w-full text-lg bg-gray-500">
          <span className="font-bold">{t("Split into Payments")}</span>{" "}
          <span>{t("Split up to 6 Payments")}</span>
        </p>
      )} */}
      <p
        ref={refBtn}
        className="flex w-full gap-4 p-3 px-1 border rounded-md cursor-pointer text-md"
        onClick={() => setShow((show) => !show)}
      >
        <ImgTag
          src={`/imgs/madfu/new/madfu-logo-${locale}.png`}
          alt="madfu logo"
          width={100}
          height={28}
          // className="object-contain h-8"
          className="h-[38px] w-auto object-contain"
          loading="eager"
          priority="high"
        />
        <span>
          {locale === "ar" ? (
            <>
              <span className="">قسم طلبك حتى 6 دفعات</span>
              <span className="font-bold">{' '}
                {(amount / 6).toLocaleString()} <CurrencyIcon className='h-[1.2cap] inline-block' />
              </span>
              <span className="">
                {" "}
                - بدون أي فوائد, متوافق مع الشريعة الإسلامية
              </span>
            </>
          ) : (
            <>
              <span className="">Split it up to 6 Payments of</span>
              <span className="font-bold">
                {(amount / 6).toLocaleString()} <CurrencyIcon className='h-[1.2cap] inline-block' />
              </span>
              <span className=""> - interest free, Sharia law Complient</span>
            </>
          )}
        </span>
      </p>
      <div ref={refModel}>
        <MadfuWidgetModal {...{ t, locale, show, setShow }} />
      </div>
    </div>
  );
};

export default Madfu;
